import { render, staticRenderFns } from "./EmailBroadcastContentStep.vue?vue&type=template&id=3b888f08&scoped=true"
import script from "./EmailBroadcastContentStep.vue?vue&type=script&lang=js"
export * from "./EmailBroadcastContentStep.vue?vue&type=script&lang=js"
import style0 from "./EmailBroadcastContentStep.vue?vue&type=style&index=0&id=3b888f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b888f08",
  null
  
)

export default component.exports